module.exports = __webpack_public_path__ + "media/journey1-D.3297c666.mp4";